import { NavLink } from 'react-router';
import styled from 'styled-components';

import { BREAKPOINTS } from '@shared/styled-system';

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	padding: 12px;

	border-bottom: 1px solid ${({ theme }) => theme.colors.transparent.light15};

	@media (${BREAKPOINTS.DESKTOP}) {
		display: none;
	}

	.swiper {
		margin: 0;
		width: 100%;

		.swiper-slide {
			width: fit-content;
		}
	}
`;

export const NavContainer = styled.div`
	display: flex;
	width: 100%;
`;

export const LinkStyled = styled(NavLink)<{ $isActive?: boolean }>`
	display: inline-flex;
	align-items: center;
	padding: 6px 8px;
	border-radius: 4px;
	font-size: 14px;
	line-height: 19px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};

	&.active {
		background-color: ${({ theme }) => theme.colors.transparent.light15};
	}
`;
